import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const PUB = process.env.PUBLIC_URL || "";

export default function PhotoGallery({ images = [] }) {
  const [i, setI] = useState(0);
  const n = images.length;

  useEffect(() => {
    if (n <= 1) return;
    const id = setInterval(() => setI((p) => (p + 1) % n), 4500);
    return () => clearInterval(id);
  }, [n]);

  if (!n) return null;
  const go = (d) => setI((p) => (p + d + n) % n);

  return (
    <div data-testid="photo-gallery">
      <div className="relative max-w-4xl mx-auto">
        <div className="relative overflow-hidden rounded-3xl shadow-2xl border border-amber-500/15 aspect-[16/10] bg-[#0A192F]">
          {images.map((src, k) => (
            <img key={k} src={src} alt={`El Timón San Juan del Sur ${k + 1}`}
              className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${k === i ? "opacity-100" : "opacity-0"}`} />
          ))}
        </div>

        <button onClick={() => go(-1)} data-testid="gallery-prev" aria-label="Previous photo"
          className="helm-nav-btn left-2 sm:-left-7">
          <span className="helm-nav-wheel" style={{ backgroundImage: `url(${PUB}/wheel.png)` }} />
          <span className="helm-nav-hub"><ChevronLeft className="h-5 w-5 text-[#0A192F]" /></span>
        </button>
        <button onClick={() => go(1)} data-testid="gallery-next" aria-label="Next photo"
          className="helm-nav-btn right-2 sm:-right-7">
          <span className="helm-nav-wheel" style={{ backgroundImage: `url(${PUB}/wheel.png)` }} />
          <span className="helm-nav-hub"><ChevronRight className="h-5 w-5 text-[#0A192F]" /></span>
        </button>
      </div>

      <div className="max-w-4xl mx-auto mt-5 flex gap-3 overflow-x-auto pb-2 justify-start sm:justify-center">
        {images.map((src, k) => (
          <button key={k} onClick={() => setI(k)} data-testid={`gallery-thumb-${k}`}
            className={`shrink-0 h-14 w-20 sm:h-16 sm:w-24 rounded-xl overflow-hidden border-2 transition-all ${k === i ? "border-amber-400 scale-105" : "border-transparent opacity-55 hover:opacity-100"}`}>
            <img src={src} alt="" className="w-full h-full object-cover" />
          </button>
        ))}
      </div>
    </div>
  );
}
